module.exports = __webpack_public_path__ + "static/media/landmark_logo.d1c9b80d.png";